import React, { Component } from 'react';
import Moment from 'moment';
import 'moment/locale/es';
import { withTranslation } from "react-i18next";
import lang from 'i18next';



class InfoPrice extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      type: props.type ?? '',
      id: props.id,
      product: props.product,
    };
  }


  static getDerivedStateFromProps(props) {
    return {
      type: props.type ?? '',
      id: props.id,
      product: props.product,
    }
  }


  renderBilled() {
    var label = lang.t('admin:price.billed1')
    if(this.state.product.data.billing === 'fortnight') {
      label = lang.t('admin:price.billed2')
    }
    if(this.state.product.data.billing === 'month') {
      label = lang.t('admin:price.billed3')
    }
    if(this.state.product.data.interval !== undefined && this.state.product.data.interval !== 1) {
      label = lang.t('admin:price.billed4')+' '+this.state.product.data.interval+' '+lang.t('admin:price.billed'+this.state.product.data.billing)
    }
    return label
  }


  renderAvailable() {
    if(this.state.type === 'payment') {
      if(this.state.id !== '') {
        var label = lang.t('admin:price.noexpiry')
        if(this.state.product.data.expires !== undefined) {
          label = lang.t('admin:price.expire')+' '+Moment().add(this.state.product.data.expires, this.state.product.data.expType).locale(lang.language).format('D MMM YYYY')
        }
        if(this.state.product.data.type === 'other') {
          label = ''
        }
        return (
          <p className="small">{label}</p>
        )
      }
    } else if(this.state.type === 'debit') {
      return (
        <p className="small">{this.renderBilled()}</p>
      )
    } else if(this.state.type === 'client') {
      return (
        <p className="small">{lang.t('admin:price.selectclient')}</p>
      )
    }
  }


  renderStock() {
    if(this.state.product.data.stock !== undefined && this.state.product.data.stock !== -1) {
      return <p className="small">{this.state.product.data.stock} {lang.t('admin:price.instock')}</p>
    }
  }


  renderPriceLabel() {
    if(this.state.product.data.type === 'other') {
      return lang.t('admin:price.amountdue')
    } else {
      var label = lang.t('admin:pay.sessions')
      if(this.state.product.data.stype === 'group') {
        label = this.state.product.data.sessions+' '+lang.t('admin:pay.group')
        if(this.state.product.data.sessions !== 1) {
          label = this.state.product.data.sessions+' '+lang.t('admin:pay.groups')
        }
        if(this.state.product.data.type === 'subscription' && this.state.product.data.sessions === 0) {
          label = lang.t('admin:price.unlimitedgroup')
        }
      } else if(this.state.product.data.stype === '11') {
        label = this.state.product.data.sessions+' '+lang.t('admin:pay.pt')
        if(this.state.product.data.sessions !== 1) {
          label = this.state.product.data.sessions+' '+lang.t('admin:pay.pts')
        }
        if(this.state.product.data.type === 'subscription' && this.state.product.data.sessions === 0) {
          label = lang.t('admin:price.unlimitedpt')
        }
      } else if(this.state.product.data.stype === 'both') {
        label = this.state.product.data.sessions+' '+lang.t('admin:pay.group')
        if(this.state.product.data.sessions !== 1) {
          label = this.state.product.data.sessions+' '+lang.t('admin:pay.groups')
        }
        if(this.state.product.data.type === 'subscription' && this.state.product.data.sessions === 0) {
          label = lang.t('admin:price.unlimitedgroup')
        }
        if(this.state.product.data.sessions11 !== 0) {
          if(this.state.product.data.sessions11 !== 1) {
            label += ' & '+this.state.product.data.sessions11+' '+lang.t('admin:pay.pts')
          } else {
            label += ' & '+this.state.product.data.sessions11+' '+lang.t('admin:pay.pt')
          }
        } else {
          label += ' '+lang.t('admin:price.unlimitedpt2')
        }
       
      }
      return label
    }
  }


  render() {
    if(this.state.id !== '') {
      return (
        <div className="info">
          <label>{this.renderPriceLabel()}</label>
          <p className="large">{global.curSym}{this.state.product.data.price.toFixed(2)}</p>
          {this.renderAvailable()}
          {this.renderStock()}
        </div>
      )
    } else {
      return null
    }
  }
}


export default withTranslation(['admin','common'])(InfoPrice);